import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import PageHero from "@/components/PageHero";
import AIForLeaders from "@/components/AIForLeaders";
import AILyftet from "@/components/AILyftet";
import AIMasterclass from "@/components/AIMasterclass";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const AISkilling = () => {
  return (
    <>
      <Helmet>
        <title>AI-skilling Programs | AI-labbet</title>
        <meta name="description" content="AI training programs for leaders and teams. Build AI capabilities with our comprehensive skilling courses and masterclasses." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <Header />
        <PageBreadcrumb currentPage="AI-skilling" />
        
        {/* Hero Section */}
        <main>
          <PageHero
            title={<>AI-skilling <span className="text-gradient-brand">Programs</span></>}
            description="Empower your organization with comprehensive AI education programs designed for leaders, teams, and professionals at every level."
            blobPosition="left"
          />

          {/* Three main sections */}
          <AIForLeaders />
          <AILyftet />
          <AIMasterclass />
          
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AISkilling;
